import { Capacitor } from '@capacitor/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PurchasesPackage = any;

const RC_KEYS = {
  ios: import.meta.env.VITE_RC_IOS_KEY as string | undefined,
  android: import.meta.env.VITE_RC_ANDROID_KEY as string | undefined,
};

let configured = false;

function platform(): 'ios' | 'android' | 'web' {
  const p = Capacitor.getPlatform();
  return (p === 'ios' || p === 'android') ? p : 'web';
}

export function iapAvailable(): boolean {
  return platform() !== 'web' && !!(RC_KEYS.ios || RC_KEYS.android);
}

export async function initIap(userId: string): Promise<void> {
  if (configured || !iapAvailable()) return;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { Purchases, LOG_LEVEL } = await import('@revenuecat/purchases-capacitor' as any);
  const apiKey = platform() === 'ios' ? RC_KEYS.ios! : RC_KEYS.android!;
  await Purchases.configure({ apiKey, appUserID: userId });
  if (import.meta.env.DEV) await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
  configured = true;
}

export async function getGemPackages(): Promise<PurchasesPackage[]> {
  if (!iapAvailable()) return [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { Purchases } = await import('@revenuecat/purchases-capacitor' as any);
  const offerings = await Purchases.getOfferings();
  return (offerings as any).current?.availablePackages ?? (offerings as any).offerings?.current?.availablePackages ?? [];
}

export interface IapPurchaseResult {
  transactionId: string;
  productId: string;
  rcUserId: string;
}

export async function buyPackage(pkg: PurchasesPackage): Promise<IapPurchaseResult> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { Purchases } = await import('@revenuecat/purchases-capacitor' as any);
  const result = await Purchases.purchasePackage({ aPackage: pkg });
  const { customerInfo, transaction } = result as any;
  return {
    transactionId: transaction?.transactionIdentifier ?? result.productIdentifier,
    productId: result.productIdentifier,
    rcUserId: customerInfo?.originalAppUserId ?? '',
  };
}
